import { createProjectLogger, createModuleLogger } from '@metamask/utils';

export const projectLogger = createProjectLogger('eth-json-rpc-middleware');

export { createModuleLogger };
